import moment from "moment";

function customDate(date) {
  let d = date?.split("T")?.[0];
  return moment(d).format("MMM DD, YYYY");
}

export default customDate;
